import React, { useEffect, useState } from "react";
import logo from "./logo.svg";
import "../App.css";
import "../scss/home.scss";
import Header from "../component/Header";
import ContainerItem from "../component/ContainerItem";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
function Home() {
  let { t } = useTranslation();
  return (
    <div className="App container-fuild home">
      <Header />
      <div className="home-table"></div>
      <div className="container-fuild p-2 VMiddle">
        <div className="row m-0">
          <div className="col-12 col-sm-12 col-md-12 col-lg-6"></div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 text-start">
            <div className="container-content home-container-content ">
              <div className="container-block text-end">
                <h1>{parse(t("home_title"))}</h1>
                <p className=" mt-4">{parse(t("home_desc"))}</p>
              </div>
            </div>
            <div className="startbutton">
              <a
                className="btn btn-next btn-start"
                href={`/ae/ar/choose-your-refrigerator/capacity`}
              >
                {t("start")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
